import * as React from "react";
import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <g>
    <path
      xmlns="http://www.w3.org/2000/svg"
      d="M11.3334 23V21C9.25009 20.7666 7.46259 19.9041 5.97092 18.4125C4.47926 16.9208 3.61676 15.1333 3.38342 13.05H1.38342V11.05H3.38342C3.61676 8.96664 4.47926 7.17914 5.97092 5.68748C7.46259 4.19581 9.25009 3.33331 11.3334 3.09998V1.09998H13.3334V3.09998C15.4168 3.33331 17.2043 4.19581 18.6959 5.68748C20.1876 7.17914 21.0501 8.96664 21.2834 11.05H23.2834V13.05H21.2834C21.0501 15.1333 20.1876 16.9208 18.6959 18.4125C17.2043 19.9041 15.4168 20.7666 13.3334 21V23H11.3334ZM12.3334 19.05C14.2668 19.05 15.9168 18.3666 17.2834 17C18.6501 15.6333 19.3334 13.9833 19.3334 12.05C19.3334 10.1166 18.6501 8.46664 17.2834 7.09998C15.9168 5.73331 14.2668 5.04998 12.3334 5.04998C10.4001 5.04998 8.75009 5.73331 7.38342 7.09998C6.01676 8.46664 5.33342 10.1166 5.33342 12.05C5.33342 13.9833 6.01676 15.6333 7.38342 17C8.75009 18.3666 10.4001 19.05 12.3334 19.05Z"
    />
  </g>,
  "AcUnit"
);
